// const BaseURL = "https://apiv1.aliflaila.app/api/admin/";
// const PublicURL = "https://apiv1.aliflaila.app/api/";

// const PublicURL = "https://api-staging.aliflaila.app/api/";
// const BaseURL = "https://api-staging.aliflaila.app/api/admin/";

const PublicURL = "https://apiv1.aliflaila.app/api/";
const BaseURL = "https://apiv1.aliflaila.app/api/admin/";

// const PublicURL = "http://127.0.0.1:8000/api/";
// const BaseURL = "http://127.0.0.1:8000/api/admin/";
const Endpoint = {
  auth: {
    login: "login",
    logout: "logout",
    sendOTP: "send-email-otp",
    verifyOTP: "verify-otp",
    resetPassword: "reset-password"
  },
  profile: {
    getProfile: "profile",
    updateProfile: "profile/update",
    changePassword: "profile/change-password",
    notificationSettings: "profile/notification-settings"
  },
  dashboard: {
    adminDashboard: "stats/adminuser/dashboard"
  },
  admin: {
    getUsers: "adminuser/users/partners",
    bookReviewers: "stats/adminuser/reviewers",
    getAllBookReviewers: "adminuser/reviewers/list",
    getBookReviewerDetails: "adminuser/reviewers/profile/",
    getBookReviewerBooks: "adminuser/reviewers/",
    getAllUsers: "adminuser/tickets/users/drop-list",
    createTicket: "adminuser/tickets/create",
    createTicketAndComment: "adminuser/tickets/create-and-comment",
    addComment: "adminuser/tickets/comment",
    allTickets: "/adminuser/tickets/users/list",
    authorStats: "/stats/adminuser/authors",
    publisherStats: "/stats/adminuser/publishers",
    createBookReviewer: "/adminuser/reviewers/create",
    getTickets: "/adminuser/tickets/list/",
    getConversation: "adminuser/tickets/thread/",
    closeTicket: "adminuser/tickets/close/",
    getAuthorDetails: "adminuser/users/author/",
    getMOUDetail: "adminuser/mou/view/",
    getAllMOUs: "adminuser/mou/list/",
    assignToHead: "/adminuser/mou/assign-to-head/",
    deleteMOU: "adminuser/mou/delete/",
    updateMOU: "adminuser/mou/update",
    createMOU: "adminuser/mou/create",
    getPublisherProfile: "adminuser/users/publisher/",
    blockReviewer: "adminuser/reviewers/block/",
    unblockReviewer: "adminuser/reviewers/unblock/",
    getAllSchoolAccounts: "/adminuser/schools/list",
    changeLimit: "/adminuser/schools/change-limit",
    approveSchool: "/adminuser/schools/approve",
    rejectSchool: "/adminuser/schools/reject",
    schoolStats: "/stats/adminuser/schools",
    blockSchool: "/adminuser/schools/block",
    unBlockSchool: "adminuser/schools/unblock",
    markTestSchool: "adminuser/users/mark-test",
    unmarkTestSchool: "adminuser/users/unmark-test",
    markTestPartner: "adminuser/users/partners/mark-test",
    unmarkTestPartner: "adminuser/users/partners/unmark-test",
    schoolDemoRequests: "/adminuser/school-demo-requests",
    getDemoRequest: "/adminuser/school-demo-requests/:id",
    reviewDemoRequest: "/adminuser/school-demo-requests/:id/update",
    activateDemoRequest: "/adminuser/school-demo-requests/:id/activate",
    getSchoolOverview: "/adminuser/schools/overview/:id",
    getBookFilterCounts: "/adminuser/books/filter-counts"
  },
  hod: {
    getStats: "stats/hodcontent/dashboard",
    getBooks: "hodcontent/books",
    getSeries: "hodcontent/series",
    bookReviewers: "stats/hodcontent/reviewers",
    getAllBookReviewers: "hodcontent/reviewers/list",
    getAllBooks: "hodcontent/books/",
    changeStatusBook: "hodcontent/books/change-status",
    changeStatusBookAudio: "hodcontent/books/change-audio-status",
    changeStatusSeries: "hodcontent/series/change-status",
    assignReviewer: "hodcontent/books/review/assign-to-reviewer",
    seriesAssignReviewer: "hodcontent/series/review/assign-to-reviewer",
    approveBooks: "hodcontent/books/approve",
    approveBooksAudio: "hodcontent/books/approve-audio",
    approveSeries: "hodcontent/series/approve",
    rejectBook: "hodcontent/books/reject",
    rejectBookAudio: "hodcontent/books/reject-audio",
    rejectSeries: "hodcontent/series/reject",
    publishBook: "hodcontent/books/publish",
    sendBackRevision: "hodcontent/books/review/send-revision",
    sendBackSeriesRevision: "hodcontent/series/review/send-revision",
    approvalPendingBooks: "hodcontent/books/review/approval-pending",
    recentRevision: "hodcontent/books/review/recent-revision/",
    recentSeriesRevision: "hodcontent/series/review/recent-revision/",
    getAllBookReviewersBooks: "hodcontent/reviewers/",
    getBookHistory: "hodcontent/books/review/history/",
    getSeriesHistory: "hodcontent/series/review/history/",
    getReviewerProfile: "/hodcontent/reviewers/profile/"
  },
  general: {
    getAllLanguages: "languages/list",
    getKeywords: "tags/list",
    getAllAgeRanges: "age-ranges/list",
    getGenres: "genres/list",
    getBookDetail: "books/details/",
    getSeriesDetail: "series/details/",
    getBookPages: "books/details/"
  },
  book_reviewer: {
    getBooks: "bookreviewer/books/list",
    getStats: "stats/bookreviewer/dashboard",
    assignBackToHOD: "bookreviewer/books/review/submit-review",
    recentHistory: "bookreviewer/books/review/history/",
    recentRevision: "bookreviewer/books/review/recent-revision/"
  },
  series_reviewer: {
    getSeries: "seriesreviewer/series/list",
    getStats: "stats/bookreviewer/dashboard",
    assignBackToHOD: "seriesreviewer/series/review/submit-review",
    recentHistory: "bookreviewer/books/review/history/",
    recentRevision: "seriesreviewer/series/review/recent-revision/"
  },
  product_manager: {
    getAllAuthors: "productmanager/book-author",
    getAllPlans: "productmanager/plans/list",
    getBooksAuthorStats: "productmanager/users/author-counts",
    getAllSchools: "productmanager/plans/schools-list",
    getSchoolUsers: "productmanager/users/schools",
    schoolStatistics: "productmanager/schools/statistics",
    schoolReadsStats: "productmanager/schools/reads-statistics",
    createPlan: "productmanager/plans/create",
    updatePlan: "productmanager/plans/update",
    deletePlan: "productmanager/plans/delete/",
    activatePlan: "productmanager/plans/activate/",
    inactivatePlan: "productmanager/plans/inactivate/",
    getAllBalance: "productmanager/topup-balance/list",
    addBalance: "productmanager/topup-balance/add",
    updateBalance: "productmanager/topup-balance/update",
    deleteBalance: "productmanager/topup-balance/delete/",
    allFeaturedBooks: "productmanager/featured-books/list",
    approveFeatureBook: "productmanager/featured-books/approve/",
    rejectFeatureBook: "productmanager/featured-books/reject",
    uploadFeatureCover: "productmanager/featured-books/upload-cover",
    getAllPublishers: "productmanager/featured-books/publishers",
    getPublisherBooks: "productmanager/featured-books/publishers/",
    addBook: "productmanager/featured-books/add",
    renewBook: "productmanager/featured-books/renew",
    activateBook: "productmanager/featured-books/activate/",
    deactivateBook: "productmanager/featured-books/deactivate/",
    bookHistory: "productmanager/featured-books/history/",
    reportedBooksLists: "productmanager/reported-books/list",
    pendingBooksLists: "productmanager/reported-books/pending-reports/",
    historyBookLists: "productmanager/reported-books/history/",
    approveBook: "productmanager/reported-books/approve/",
    declineBook: "productmanager/reported-books/decline/",
    allGenres: "productmanager/genres/list",
    updateGenres: "productmanager/genres/update",
    deleteGenres: "productmanager/genres/delete/",
    createGenre: "productmanager/genres/create",
    activateGenre: "productmanager/genres/activate/",
    inactiveGenre: "productmanager/genres/inactivate/",
    allKeywords: "productmanager/keywords/list",
    allTags: "productmanager/tags/list",
    createKeyword: "productmanager/keywords/create",
    updateKeyword: "productmanager/keywords/update",
    deleteKeyword: "productmanager/keywords/delete/",
    activateKeyword: "productmanager/keywords/activate/",
    inactiveKeyword: "productmanager/keywords/inactivate/",
    createTags: "productmanager/tags/create",
    updateTags: "productmanager/tags/update",
    deleteTags: "productmanager/tags/delete/",
    activateTags: "productmanager/tags/activate/",
    inactiveTags: "productmanager/tags/inactivate/",
    ticketUsers: "productmanager/tickets/users/list",
    createTicket: "productmanager/tickets/create",
    createTicketAndCommentByProductManager:
      "productmanager/tickets/create-and-comment",
    addComment: "productmanager/tickets/comment",
    closeTicket: "productmanager/tickets/close/",
    userTickets: "productmanager/tickets/list/",
    getAllComments: "productmanager/tickets/thread/",
    getAllUserList: "productmanager/tickets/users/drop-list",
    catalogStats: "stats/productmanager/catalogs",
    genreStats: "stats/productmanager/popular-genres",
    booksStats: "stats/productmanager/popular-books",
    softCopySales: "stats/productmanager/graph/soft-copy-sales",
    hardCopySales: "stats/productmanager/graph/hard-copy-sales",
    topSalesSoftCopy: "productmanager/books/top-sales/softcopies",
    topSalesHardCopy: "productmanager/books/top-sales/hardcopies",
    deleteBook: "productmanager/books/delete/",
    revisionHistory: "productmanager/reported-books/revision/history/",
    allGraphs: "stats/productmanager/graph/book-sales",
    salesBooks: "productmanager/books/best-sellers",
    transactionRequests: "productmanager/user-subscriptions/transactions/list",
    subscriptionRequests:
      "/productmanager/user-subscriptions/subscriptions/list",
    userTransactionsList:
      "/productmanager/user-subscriptions/transactions/list",
    rejectTransactionRequest:
      "productmanager/user-subscriptions/transactions/reject",
    approveTransactionRequest:
      "productmanager/user-subscriptions/transactions/approve",
    getPolicyDataAPI: "productmanager/pages/content",
    updateGetPolicyDataAPI: "productmanager/pages/update",
    getNewsletterListProductManager: "/productmanager/newsletters/list",
    deleteNewsletterProductManager: "/productmanager/newsletters/delete/",
    transactionHistoryList:
      "/productmanager/user-subscriptions/payment-transactions/list",
    transactionInquiry:
      "/productmanager/user-subscriptions/payment-transactions/:id/inquiry",
    planPayments: "/productmanager/user-subscriptions/plan-payments/list",
    refundedPlanPayments:
      "/productmanager/user-subscriptions/plan-payments/refunded/list",
    bannerListings: "/productmanager/banners/list",
    deleteBanner: "/productmanager/banners/delete/:id",
    addBanner: "/productmanager/banners/add",
    individualAccounts: "/productmanager/users/individuals",
    parentsAccounts: "/productmanager/users/parents",
    blockUser: "/productmanager/users/block/:id",
    unblockUser: "/productmanager/users/unblock/:id",
    markTestUser: "productmanager/users/mark-test/:id",
    unmarkTestUser: "productmanager/users/unmark-test/:id",
    statsParents: "/stats/productmanager/users/parents",
    statsIndividual: "/stats/productmanager/users/individuals ",
    getAllPublishersList: "productmanager/users/active-publishers-droplist",
    getAllAuthorsList: "productmanager/users/active-authors-droplist",
    getAllBooksList: "productmanager/books/published-books-droplist",
    getAllCustomNotifications: "productmanager/notifications/list-campaigns",
    getCustomNotification: "productmanager/notifications/campaign/:id",
    cancelNotification: "productmanager/notifications/cancel-campaign/:id",
    createNotification: "productmanager/notifications/send",
    publisherProfile: "productmanager/users/publisher/",
    authorProfile: "productmanager/users/author/",
    editAuthorProfile: "productmanager/book-author/edit/",
    getAllBanners: "productmanager/announcements/list",
    createPhotoLink: "productmanager/announcements/image-s3bucket-link",
    addAnnouncementBanners: "productmanager/announcements/add",
    updateAnnouncementStatus: "productmanager/announcements/update-status",
    deleteAnnouncementStatus: "productmanager/announcements/delete/:id",
    getSingleAnnouncement: "productmanager/announcements/show/:id",
    updateAnnouncements: "productmanager/announcements/update/:id",
    qrCodeGenerate: "productmanager/subscription-qr/generate",
    qrCodeGenerateBulk: "productmanager/subscription-qr/generate-bulk",
    qrCodeList: "productmanager/subscription-qr/list",
    qrCodeEvents: "productmanager/subscription-qr/events",
    qrCodeStatistics: "productmanager/subscription-qr/statistics",
    qrCodeActivate: "productmanager/subscription-qr/activate/",
    qrCodeDeactivate: "productmanager/subscription-qr/deactivate/",
    qrCodeDelete: "productmanager/subscription-qr/delete/",
    qrCodeDownloadSingle: "productmanager/subscription-qr/download/single/",
    qrCodeDownloadEvent: "productmanager/subscription-qr/download/event/",
    qrCodeDownloadAll: "productmanager/subscription-qr/download/all",
    analyticsOverview: "productmanager/analytics/overview",
    analyticsInstalls: "productmanager/analytics/installs",
    analyticsUninstalls: "productmanager/analytics/uninstalls",
    analyticsDevices: "productmanager/analytics/devices",
    analyticsActivity: "productmanager/analytics/activity",
    analyticsRetention: "productmanager/analytics/retention"
  },
  project_head: {
    allReportedUsers: "projecthead/reported-users/list",
    pendingReports: "projecthead/reported-users/pending-reports/",
    reportHistory: "projecthead/reported-users/history/",
    approveReport: "projecthead/reported-users/approve/",
    declineReport: "projecthead/reported-users/decline/",
    deleteReports: "projecthead/reported-users/delete/",
    publisherProfile: "projecthead/users/publisher/",
    authorProfile: "projecthead/users/author/",
    allMOUs: "projecthead/mou/list/",
    singleMOU: "projecthead/mou/view/",
    deleteMOU: "projecthead/mou/delete/",
    signAgreement: "projecthead/mou/sign-agreement",
    signAgreementOnly: "projecthead/mou/sign-agreement-only",
    getAllUsers: "projecthead/users/partners",
    getStats: "stats/projecthead/partners",
    getReviewerStats: "stats/projecthead/reviewers",
    getReviewersList: "projecthead/reviewers/list",
    getReviewerProfile: "projecthead/reviewers/profile/",
    getReviewerBooks: "projecthead/reviewers/",
    getBestSellers: "projecthead/books/best-sellers",
    stats: "stats/projecthead/dashboard",
    userGraph: "stats/projecthead/graph/users",
    coinsGraph: "stats/projecthead/graph/coins-earnings",
    softCopyGraph: "stats/projecthead/graph/soft-copy-sales",
    membershipGraph: "stats/projecthead/graph/memberships",
    reviewerStats: "projecthead/reviewers/profile/",
    blockUser: "projecthead/users/block/",
    unblockUser: "projecthead/users/unblock/",
    transactionsList: "projecthead/transactions/list",
    updateTransactionStatus: "projecthead/transactions/update-status",
    earningBookSales: "projecthead/earnings/:id/sales",
    getTransactionStats: "stats/projecthead/payments",
    rejectMOU: "projecthead/mou/reject/",
    getNewsletterProjectHead: "/projecthead/newsletters/list",
    deleteNewsletterProjectHead: "/projecthead/newsletters/delete/",
    subsciptionRequests: "/projecthead/user-subscriptions/subscriptions/list",
    getUserTransactionListForProjectHead:
      "/projecthead/user-subscriptions/transactions/list",
    planPayments: "/projecthead/user-subscriptions/plan-payments/list",
    blockPartnerUser: "/projecthead/users/block",
    unBlockPartnerUser: "/projecthead/users/unblock",
    getAllPublishers: "projecthead/users/active-publishers-droplist",
    getAllAuthors: "projecthead/users/active-authors-droplist",
    getAllBooks: "projecthead/books/published-books-droplist",
    getAllCustomNotifications: "projecthead/notifications/list-campaigns",
    getCustomNotification: "projecthead/notifications/campaign/:id",
    cancelNotification: "projecthead/notifications/cancel-campaign/:id",
    createNotification: "projecthead/notifications/send",
    dashboardstats: "stats/projecthead/graph/reader-and-schools-details",
    earningStats: "stats/projecthead/graph/total-earnings",
    partnerGraphsStats: "/stats/projecthead/graph/partners-details",
    userStatsDetails: "stats/projecthead/graph/user-account-stats",
    userGraphDetails: "stats/projecthead/graph/user-graphical-stats",
    userListings: "stats/projecthead/graph/user-listing-stats",
    earningDetailStats: "stats/projecthead/graph/total-earning-stats",
    earningIncomeGraph: "stats/projecthead/graph/total-earning-graph",
    earningAliflailaGraph: "stats/projecthead/graph/total-aliflaila-graph",
    totalPlatformGraph: "stats/projecthead/graph/total-platofrm-graph",
    partnersStatsDetails: "stats/projecthead/graph/partners-accounts-stats",
    parntersListings: "stats/projecthead/graph/partners-listing-stats",
    pendingTasksCounter: "stats/projecthead/graph/pending-tasks",
    blockRequests: "projecthead/requests/list",
    rejectRequest: "projecthead/users/reject/:id",
    pendingtasksList: "stats/projecthead/graph/detail-pending-tasks",
    school_stat: {
      overallStat: "projecthead/school-stat/overall-stat",
      dashboard: "projecthead/school-stat/dashboard",
      readerSchools: "projecthead/school-stat/readerSchool",
      healthStat: "projecthead/school-stat/health-stat",
      seatFunnel: "projecthead/school-stat/seat-funnel",
      nobodyAssigning: "projecthead/school-stat/nobody-assigning-school",
      readingMix: "projecthead/school-stat/reading-mix",
      topBooks: "projecthead/school-stat/top-books",
      readingGrowthTrend: "projecthead/school-stat/reading-growth-trend",
      regularReader: "projecthead/school-stat/regular-reader",
      readingLevel: "projecthead/school-stat/reading-level",
      assignmentCount: "projecthead/school-stat/assignment-count"
    }
  },
  accountant: {
    getEarnings: "accountant/earnings/list",
    earningBookSales: "accountant/earnings/:id/sales",
    uploadReceipt: "accountant/earnings/upload-receipt",
    getBankAccounts: "accountant/user/accounts",
    getStats: "stats/accountant/payments",
    createCoupon: "accountant/coupons/create",
    getCoupons: "accountant/coupons/list",
    getCouponById: "accountant/coupons/show",
    updateCoupon: "accountant/coupons/update",
    deleteCoupon: "accountant/coupons/delete"
  },
  /**
   * A school's own plan and payment history — the same two routes the school
   * panel's Membership Plans screen uses. They live on the school API and take
   * the school's user id in the path.
   */
  school_membership: {
    plansHistory: "school/get-plans", // + /{schoolId}
    paymentHistory: "school/get-payments", // + /{schoolId}
    installments: "school/plans-installments", // + /{planId}?user_id={schoolId}
  },
  /**
   * Single-school (campus) analytics — the twin of `school_head_office`, used
   * for schools where `is_multi_campus` is 0. Same school API, class-level rows
   * instead of campus-level ones.
   */
  school_campus: {
    dashboard: "school/dashboard-v1",
    readerClass: "school/reader-class-v1",
    readerClassDetail: "school/reader-class-v1/", // + classId
    gradeDrilldown: "school/grade-v1/", // + classId (?type=student|class-health|teacher)
    studentDetail: "school/student/", // + studentId
    teacherDetail: "school/teacher/", // + teacherId
    adoptionRate: "school/adoption-rate-v1",
    readingMix: "school/reading-mix-v1",
    topTeachers: "school/top-teachers-v1",
    topStudents: "school/top-students-v1",
    bookContentAnalysis: "school/book-content-analysis-v1",
    teacherAdoption: "school/teacher-adoption-v1",
    readingGrowthTrend: "school/reading-growth-trend-v1",
    classComparison: "school/class-comparison-v1"
  },
  /**
   * School head-office analytics. These live on the school API (PublicURL, i.e.
   * `/api/`), NOT under the admin base — they are called through
   * SCHOOL_HTTP_CLIENT, which scopes every request to a `school_id`.
   */
  school_head_office: {
    dashboard: "school/head-office/dashboard",
    readerCampus: "school/head-office/reader-campus",
    readerCampusDetail: "school/head-office/reader-campus/", // + campusId
    campusDrilldown: "school/head-office/campus/", // + campusId (?type=class|student|teacher)
    studentDetail: "school/student/", // + studentId
    teacherDetail: "school/teacher/", // + teacherId
    topTeachers: "school/head-office/top-teachers",
    topStudents: "school/head-office/top-students",
    adoptionRate: "school/head-office/adoption-rate",
    readingMix: "school/head-office/reading-mix",
    bookContentAnalysis: "school/head-office/book-content-analysis",
    campusComparison: "school/head-office/campus-comparison",
    capacity: "school/head-office/capacity",
    teacherAdoption: "school/head-office/teacher-adoption",
    readingGrowthTrend: "school/head-office/reading-growth-trend"
  }
};

export { BaseURL, Endpoint, PublicURL };
